export type Theme = 'light' | 'dark'

export const THEME_STORAGE_KEY = 'omikina-theme'
export const THEME_CHANGED_EVENT = 'omikina-theme-changed'

export function resolveTheme(value: string | null | undefined): Theme {
  return value === 'dark' ? 'dark' : 'light'
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme
  document.documentElement.style.colorScheme = theme
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? '#050708' : '#ffffff')
}

export function setTheme(theme: Theme): void {
  applyTheme(theme)
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme)
  } catch {
    // The switch still works when browser storage is unavailable.
  }
  window.dispatchEvent(new Event(THEME_CHANGED_EVENT))
}

export function subscribeToTheme(onChange: () => void): () => void {
  const onStorage = (event: StorageEvent) => {
    if (event.key !== THEME_STORAGE_KEY && event.key !== null) return
    applyTheme(resolveTheme(event.newValue))
    onChange()
  }
  window.addEventListener(THEME_CHANGED_EVENT, onChange)
  window.addEventListener('storage', onStorage)
  return () => {
    window.removeEventListener(THEME_CHANGED_EVENT, onChange)
    window.removeEventListener('storage', onStorage)
  }
}

export function getTheme(): Theme {
  return resolveTheme(document.documentElement.dataset.theme)
}
